// extracted by mini-css-extract-plugin
module.exports = {"button":"code-block-footer_button__TNCq_","link":"code-block-footer_link__rwHA8","round":"code-block-footer_round__rqS_d"};